import { PlusIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { Button } from '@va/ui/design-system';
import classNames from 'classnames';
import { useCallback, useState } from 'react';
import { AddFilterTooltip } from './add-filter-tooltip/AddFilterTooltip';
import { useFiltersContext } from './filters-context';

export const StaticLayoutFilterButton = ({ className }: { className?: string }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const { appliedFilters } = useFiltersContext();

  const translate = useTranslate();
  const filtersExist = appliedFilters.length > 0;

  const handleButtonClick = useCallback(() => {
    setIsDropdownOpen((prev) => !prev);
  }, []);

  return (
    <AddFilterTooltip isOpen={isDropdownOpen} openChange={setIsDropdownOpen}>
      <div className={classNames(className)}>
        <Button
          className='text-grey-charcoal w-full flex justify-center'
          color={filtersExist ? 'primary' : 'tertiary'}
          text={translate('button.addNewFilter')}
          icon={() => <PlusIcon className='h-18 w-18' />}
          onClick={handleButtonClick}
        />
      </div>
    </AddFilterTooltip>
  );
};
